module.exports = __webpack_public_path__ + "static/media/25.1774900f.jpg";